// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".skill1{color:#c66}.skill2{color:red}.skill3{color:#fc3}.skill4{color:#609}.skill5{color:#006}.skill6{color:#060}.skill7{color:#996}.skill8{color:#960}.skill9{color:#999}.skill10{color:#000}.colored-skill{font-weight:bold}", ""]);
// Exports
module.exports = exports;
